import React from 'react'

import * as S from './styles'

export function ProfileOrderServiceShimmer() {
  return (
    <>
      <div>
        <S.ShimmerOrderService />
      </div>

      <div>
        <S.ShimmerOrderService />
      </div>

      <div>
        <S.ShimmerOrderService />
      </div>

      <div>
        <S.ShimmerOrderService />
      </div>

      <div>
        <S.ShimmerOrderService />
      </div>

      <div>
        <S.ShimmerOrderService />
      </div>
    </>
  )
}
